module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings-section"
  }, [_vm._m(0), _vm._v(" "), _c('StatisticsCards', {
    attrs: {
      "statistics": _vm.statistics
    }
  }), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "1",
      "title": "Download your product list",
      "description": "Get a CSV with all your products. Fill in the COGS and Other Costs columns."
    }
  }, [_c('button', {
    staticClass: "download-button",
    attrs: {
      "disabled": _vm.downloading
    },
    on: {
      "click": function($event) {
        return _vm.$emit('download-template')
      }
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("\n      Download CSV Template\n    ")]), _vm._v(" "), _c('CSVExample')], 1), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "2",
      "title": "Fill in your costs",
      "description": "Open in Excel or Google Sheets. Enter COGS (required) and Other Costs (optional - shipping, prep, etc.)"
    }
  }), _vm._v(" "), _c('WorkflowStep', {
    attrs: {
      "step-number": "3",
      "title": "Upload completed file",
      "description": "Drag and drop your file or click to browse."
    }
  }, [_c('FileUploadArea', {
    attrs: {
      "uploading": _vm.uploading
    },
    on: {
      "file-selected": function($event) {
        return _vm.$emit('file-selected', $event)
      },
      "file-removed": function($event) {
        return _vm.$emit('file-removed')
      },
      "error": function($event) {
        return _vm.$emit('error', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Bulk Import Product Costs")]), _vm._v(" "), _c('span', {
    staticClass: "optional-badge"
  }, [_vm._v("OPTIONAL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a1556bf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/BulkImportSection.vue
// module id = 786
// module chunks = 2